export default "__VITE_ASSET__df490c3e__"